function isJson(value: any) {
	try {
		JSON.parse(value);
	} catch (e) {
		return false;
	}
	return true;
}

export const setSession = (key: string, value: any): void => {
	sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSession = (key: string): any => {
	const value = sessionStorage.getItem(key);
	if (value && isJson(value)) {
		return JSON.parse(value);
	}
	return sessionStorage.getItem(key);
};

export const clearSession = (key: string) => {
	sessionStorage.removeItem(key);
};

export const clearAllSession = () => {
	sessionStorage.clear();
};
